import { useEffect } from "react";
import { $sidebar } from "store/sidebar";

export default function Dashboard() {
  useEffect(() => {
    $sidebar.setPageTitle("Главная");
  }, []);

  return null;
}
